// src/js/config/orderState.js

let currentLoadedPackageConfig = null;

/**
 * Sparar den senast laddade konfigurationen i minnet.
 * @param {Object} config - Konfigurationsobjektet.
 */
export function setLoadedPackageConfig(config) {
    currentLoadedPackageConfig = config;
}

/**
 * Hämtar den senast laddade konfigurationen från minnet.
 * @returns {Object|null} Konfigurationsobjektet.
 */
export function getLoadedPackageConfig() {
    return currentLoadedPackageConfig;
}